<template>
  <div>
    <div class="main_visual">
      <swiper
        v-if="mainbanner.length > 0"
        class="swiper"
        ref="mainSwiper"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(banner, idx) in mainbanner"
          :key="idx"
          class="slide-wrap"
          :style="{
            backgroundImage:
              'url(' + $options.filters.get_img(banner.filepath) + ')',
          }"
        >
          <div class="wrap">
            <div class="slide-content">
              <a v-if="banner.mb_link" :href="banner.mb_link" target="_blank">
                <strong>{{ banner.mb_title }}</strong>
                <p>{{ banner.mb_sub_title }}</p>
              </a>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div class="wrap">
        <div class="pagination-wrap">
          <div class="swiper-pagination"></div>
          <button class="play">
            <i
              class="material-icons-outlined"
              v-if="stopbtn === 'y'"
              @click="swiper_stop"
              >pause</i
            >
            <i
              class="material-icons"
              v-if="playbtn === 'y'"
              @click="swiper_play"
              >play_arrow</i
            >
          </button>
        </div>
      </div>
    </div>

    <div class="championship wrap">
      <h2 class="section-title text-capitalize" @click="goto_url('tournament')">
        {{ $t("title.main.tournament")
        }}<i class="material-icons">navigate_next</i>
      </h2>
      <span class="section-describe">{{
        $t("text.main.tournament_describe")
      }}</span>
      <Tournament v-bind:tournamentlist="tournamenttop" />
    </div>

    <div class="bg-wrap">
      <!-- <div class="main_lesson">
        <div class="wrap">
          <h2 class="section-title" @click="goto_url('lesson')">
            {{ $t("title.main.netizen_lesson") }}<i class="material-icons">navigate_next</i>
          </h2>
          <span class="section-describe">{{ $t("text.main.netizen_lesson_describe") }}</span>
          <Lesson v-bind:swinglist="swingtop" />
        </div>
      </div> -->
      <div class="main_cc">
        <div class="wrap">
          <Course v-bind:courselist="coursetop" />
        </div>
      </div>
    </div>

    <!-- <div class="main_social">
      <div class="wrap text-center">
        <a href="https://www.instagram.com/xgolfofficial/" target="_blank">
          <h2 class="section-title">
            {{ $t("title.main.social_media")
            }}<i class="material-icons">navigate_next</i>
          </h2>
        </a>
        <span class="section-describe">{{
          $t("text.main.social_media_describe")
        }}</span>
      </div>
      <Socialmedia />
    </div> -->
  </div>
</template>

<script>
import Tournament from "@/components/main/Tournament";
import Lesson from "@/components/main/Lesson";
import Course from "@/components/main/Course";
import Socialmedia from "@/components/main/Socialmedia";
import ax from "@/api/main";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import i18n from "@/i18n";

export default {
  name: "Main",
  data() {
    return {
      mainbanner: [],
      tournamenttop: [],
      swingtop: [],
      coursetop: [],
      playbtn: "n",
      stopbtn: "y",
      swiperOptions: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            const banner = this.mainbanner[index];
            const label = banner ? banner.mb_description : "";
            return '<span class="' + className + '">' + label + "</span>";
          },
        },
      },
    };
  },
  components: {
    Tournament,
    Lesson,
    Socialmedia,
    Course,
    Swiper,
    SwiperSlide,
  },
  methods: {
    get_main() {
      ax.get_main((flag, data) => {
        if (flag) {
          this.mainbanner = data.mainbanner;
          this.tournamenttop = data.tournamenttop;
          this.swingtop = data.swingtop;
          this.coursetop = data.coursetop;

          // mainbanner 받은 후 swiperOptions 갱신
          this.swiperOptions.pagination.renderBullet = (index, className) => {
            const banner = this.mainbanner[index];
            const label = banner ? banner.mb_description : "1111";
            return '<span class="' + className + '">' + label + "</span>";
          };
        } else {
          this.data_yn = false;
          this.$notify({
            group: "alert",
            type: "warn",
            text: data,
            duration: 5000,
            speed: 1000,
          });
        }
      });
    },
    goto_url(type) {
      if (type === "tournament") {
        this.$router.push("/tournament/tournamentschedule");
      } else if (type === "lesson") {
        this.$router.push("/event/netizenlesson");
      }
    },
    swiper_stop() {
      this.$refs.mainSwiper.$swiper.autoplay.stop();
      this.stopbtn = "n";
      this.playbtn = "y";
    },
    swiper_play() {
      this.$refs.mainSwiper.$swiper.autoplay.start();
      this.stopbtn = "y";
      this.playbtn = "n";
    },
  },
  created() {
    this.get_main();
  },
};
</script>
